import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2, UserRound } from "lucide-react";

export default function MinhaSaude() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasPatient, setHasPatient] = useState(true);

  useEffect(() => {
    const loadMyPatient = async () => {
      try {
        const {
          data: { user },
        } = await supabase.auth.getUser();

        if (!user) return;

        const { data, error } = await supabase
          .from("patients_onboarding")
          .select("id")
          .eq("owner_id", user.id)
          .order("created_at", { ascending: true })
          .limit(1)
          .maybeSingle();

        if (error) throw error;

        if (data?.id) {
          navigate(`/paciente/minha-saude/${data.id}`, { replace: true });
          return;
        }

        setHasPatient(false);
      } catch (error) {
        console.error("Erro ao carregar Minha Saúde:", error);
        setHasPatient(false);
      } finally {
        setLoading(false);
      }
    };

    void loadMyPatient();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[240px]">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!hasPatient) {
    return (
      <Card>
        <CardContent className="py-10 flex flex-col items-center gap-4 text-center">
          <UserRound className="h-10 w-10 text-muted-foreground" />
          <div>
            <p className="font-medium">Seu perfil de saude ainda nao foi criado.</p>
            <p className="text-sm text-muted-foreground">
              Atualize a pagina em alguns segundos para tentar novamente.
            </p>
          </div>
          <Button onClick={() => window.location.reload()}>Atualizar</Button>
        </CardContent>
      </Card>
    );
  }

  return null;
}
